import Vue from 'vue'
import VueGtag from 'vue-gtag'
import { resolveUserRole } from '@/utils/analyticsRole'

// GA4 - ARG tenant, production only (matches ipro-portal-ui).
export function installAnalytics(router) {
  const gaId = process.env.VUE_APP_GA_ID
  const isArgTenant = window.location.hostname.includes('arg')
  const isProd = process.env.NODE_ENV === 'production'

  if (gaId && isArgTenant && isProd) {
    try {
      Vue.use(
        VueGtag,
        {
          config: {
            id: gaId,
            params: {
              send_page_view: false // Router handles page views
            }
          },
          appName: 'ARG TPR Manager',
          pageTrackerTemplate(to) {
            return {
              page_title: to.meta?.title || to.name,
              page_path: to.path
            }
          }
        },
        router
      )
    } catch (e) {
      console.warn('Google Analytics failed to initialize:', e)
    }
  }

  // No-op fallback - $gtag never throws when GA is disabled or failed to load
  if (!Vue.prototype.$gtag) {
    const log = process.env.VUE_APP_ENV === 'local'
    const noop = (action, ...args) => {
      if (log) console.log(`[GA Mock] ${action}:`, ...args)
    }
    Vue.prototype.$gtag = {
      event: (action, params) => noop('event', action, params),
      pageview: page => noop('pageview', page),
      screenview: screen => noop('screenview', screen),
      customMap: map => noop('customMap', map),
      time: params => noop('time', params),
      exception: params => noop('exception', params),
      set: (...args) => noop('set', ...args),
      config: (...args) => noop('config', ...args),
      query: (...args) => noop('query', ...args)
    }
  }
}

export function setAnalyticsUser(roles) {
  Vue.prototype.$gtag?.set('user_properties', { user_role: resolveUserRole(roles) })
}
